import { Box, SwipeableDrawer, Button, useTheme } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { REFINABLE_FACET_KEYS, useFacets, useToggle } from 'hooks';
import { REFINE_WIDTH } from 'constants/sizing';
import { IFacetSection } from 'api/catalog/models';
import StyledSideBadge from 'ui/StyledSideBadge';

import messages from './messages';
import Facets from './Facets';

interface IProps {
  facets?: IFacetSection[];
}

const Refine = ({ facets }: IProps) => {
  const theme = useTheme();
  const { val: isRefineOpen, toggle: toggleIsRefineOpen } = useToggle();
  const { getCurrentlyAppliedCount, isSearchApplied } = useFacets();

  const totalSelected = useMemo(() => {
    return (
      REFINABLE_FACET_KEYS.reduce(
        (acc, currKey) => acc + getCurrentlyAppliedCount(currKey),
        0
      ) + (isSearchApplied() ? 1 : 0)
    );
  }, [getCurrentlyAppliedCount, isSearchApplied]);

  return (
    <React.Fragment>
      <Button variant='contained' onClick={toggleIsRefineOpen}>
        <FormattedMessage {...messages.buttonText} />
        {totalSelected > 0 ? (
          <StyledSideBadge
            sx={{
              '& .MuiBadge-badge': {
                backgroundColor: theme.palette.common.white,
                color: theme.palette.primary.dark,
              },
            }}
            badgeContent={totalSelected}
            color='secondary'
          />
        ) : null}
        <TuneIcon sx={{ marginLeft: '10px' }} />
      </Button>
      <SwipeableDrawer
        anchor='left'
        open={isRefineOpen}
        onClose={toggleIsRefineOpen}
        onOpen={toggleIsRefineOpen}
      >
        {isRefineOpen && facets ? (
          <Box sx={{ width: REFINE_WIDTH }}>
            <Facets
              facets={facets}
              onCancel={toggleIsRefineOpen}
              onApplied={toggleIsRefineOpen}
            />
          </Box>
        ) : null}
      </SwipeableDrawer>
    </React.Fragment>
  );
};

export default Refine;
